import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=183b63ee&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=183b63ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b63ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183b63ee')) {
      api.createRecord('183b63ee', component.options)
    } else {
      api.reload('183b63ee', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=183b63ee&scoped=true", function () {
      api.rerender('183b63ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/Main.vue"
export default component.exports